export const LIST = 'list';
export const TIMELINE = 'timeline';
export const OVERVIEW = 'overview';
